const MesureDeleteStyle = {
  bg: "white",
};

export { MesureDeleteStyle };
